// LoginPopup.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'
import { backend } from '../config';
import '../Styles/LoginPopup.css';
import { setAuthenticated } from '../auth';

const LoginPopup = ({ onClose, onLoginSuccess }) => {
  const [errorMessage, setErrorMessage] = useState(null);

  const navigate = useNavigate();

  const handleClose = () => {
    onClose();
    navigate('/');
  };

  const handleSubmit = async (e) => {
    const BUTTON = document.getElementById("loginButton")
    BUTTON.classList.add("disabled");
    BUTTON.setAttribute("disabled", true);

    e.preventDefault();
    const username = e.target.username.value;
    let password = e.target.password.value;
  
    const response = await fetch(backend+'reg/authenticate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username, password }),
    });
    password = null // clear garbage collection
  
    if (response.ok) {
      const data = await response.json();
      console.log(data)
      sessionStorage.setItem('authToken', data.token);
      sessionStorage.setItem('username', username);
      sessionStorage.setItem('companyName', data.companyName);
      setAuthenticated(true);
      document.getElementById("userName").innerHTML = username
      onClose();
      if (onLoginSuccess) { // Add this line
        onLoginSuccess(); // Add this line
      }
    } else {
      setErrorMessage('Invalid username or password');
    }
    BUTTON.classList.remove("disabled");
    BUTTON.removeAttribute("disabled");
  };
  

  return (
    <div className="bc-login-popup">
      <div className="bc-login-popup-content">
      <button className="close-popup" onClick={handleClose}>
          &times;
        </button>
        <h2>Welcome back!</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="username"
            placeholder="Username"
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            required
          />
          <button id="loginButton" type="submit">Login</button>
        </form>
        {errorMessage && (
          <p className="error-message">{errorMessage}</p>
        )}
      </div>
    </div>
  );
};

export default LoginPopup;
